export default "__VITE_ASSET__e8356b47__"